import React, { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Divider from "../ui/Divider";
import Label, { DisplayLabel } from "../ui/Label";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import POSList from "../components/POSList";
import Input from "../ui/Input";
import Float from "../ui/Float";
import POSDetails from "../components/POSDetails";
import Nav from "../ui/Nav";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import POSItems from "../components/POSItems";
import POSEdit from "../components/POSEdit";
import { createScreen } from "../hooks/createScreen";
import { TRANSACTION } from "../utils/Struct";
import { drawPicker } from "../popovers/Picker";
import { ENUMS } from "../utils/Enums";
import Cookies from "js-cookie";
import { requestPrompt } from "../utils/Utils";

export default function POSController(props) {

    const { controller = "", signal = {}, setController = () => { } } = props;

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});
    const [items, setItems] = useState([]);
    const [align, setAlign] = useState("auto");
    const row_key = "acr_id";
    const [state, setState] = useState(
        {
            edit: false,
            view: "list",
        }
    )


    const toggleView = () => {
        if (state?.edit) {
            return;
        }

        console.log(state.view)
        if (state?.view === "list") {
            setState({ ...state, "view": "items" })
        } else {
            setState({ ...state, "view": "list" })
        }

    }



    const pos_nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },
        { text: "Cpy" },
        { key: KBD.V, text: "View", action: () => toggleView() },
        { key: KBD.N, text: "New", action: () => newTransaction() },
        { text: "Del" },
        { key: KBD.E, text: "Edt", action: () => editTransaction() },
        { text: "@Edt" },
     
        { text: "GftRct" },
    ]

    useEffect(() => {
        window.bm_state.value = ROUTES.POS.POS;
    }, [])

    useEffect(() => {

        const cleanup = listen(controller, ROUTES.POS.POS, pos_nav);
        return cleanup;
    }, [pos_nav])


    useEffect(() => {
        if (selected?.[row_key]) {
            Cookies.set("pos_id", selected?.[row_key]);
        }
    }, [selected])

    useEffect(() => {

        if (!selected?.invoice) { return; }

        pubCall("point_of_sale.getSingle", { invoice: selected?.invoice }, (_s, _r) => {
            if (_s) {
                setItems(_r?.items || [])
            } else {
                showError(_r);
            }
        })

    }, [selected?.invoice])




    const newTransaction = () => {
        window.bm_state.value = ROUTES.POS.EDIT;
        const transaction = { ...TRANSACTION };
        setState({ ...state, "view": "items", edit: true })
        setSelected(transaction);
        setItems([])
    }

    const editTransaction = () => {
        window.bm_state.value = ROUTES.POS.EDIT;
        setState({ ...state, "view": "items", edit: true })

    }


    const cancelEdit = (_ref, _return_route) => {

        if (_ref && typeof _ref?.blur === "function") {
            _ref.blur();
        }

        drawPicker({
            controller: controller,
            value: "R", title: "Select Status", closeable: true, height: 300, ref: null,
            close: () => {
                window.bm_state.value = _return_route;
                if (_ref && typeof _ref?.focus === "function") {
                    _ref.focus();
                }

            },
            callback: (e) => {
                window.bm_state.value = ROUTES.POS.POS;
                setState({ ...state, edit: false, view: "list" });
            }, offset: [0, 10],
            options: ENUMS.TRANSACTION_INTERUPTED
        })
    }


    const fetch = () => {
        if (loading) { return }
        setLoading(true);
        let _filters = {};
        _filters.limit = 45;
        if (selected?.[row_key]) {
            _filters[row_key] = selected?.[row_key];
        }




        pubCall("point_of_sale.getLast", _filters, (_s, _r) => {
            if (_s) {
                if (_r.length > 0) {
                    //setAlign("end");
                }
                setData(_r);

                setSelected((_r.length > 0) ? _r[_r.length - 1] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, []);




    return (
        <div className="controller">
            <div style={{ height: "calc(100vh - 74px)", minHeight: "600px", gap: "15px" }}>

                <POSDetails
                    controller={controller}
                    selected={selected}
                    setSelected={setSelected}
                    state={state}
                    setState={setState}
                    cancelEdit={cancelEdit}
                />
                <div className="shim" />


                <POSList
                    row_key={row_key}
                    controller={controller}
                    loading={loading}
                    setLoading={setLoading}
                    route={ROUTES.POS.POS}
                    data={data}
                    setData={setData}
                    selected={selected}
                    setSelected={setSelected}
                    signal={signal}
                    align={align}
                    setAlign={setAlign}
                    state={state}
                    setState={setState}
                />

                {((state?.view === "items" || state?.view === "customer") &&
                    <POSItems
                        controller={controller}
                        state={state}
                        setState={setState}
                        loading={loading}
                        setLoading={setLoading}
                        route={ROUTES.POS.EDIT}
                        data={items || []}
                        signal={signal}
                        cancelEdit={cancelEdit}
                    />
                )}
                <div className="shim" />
                <Divider />
                <div style={{ 'height': "30px" }}>

                    <Space style={{ "padding": "0px 15px" }}>
                        <Nav nav={pos_nav} />
                    </Space>

                </div>
            </div>
        </div>
    )
}